import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'

import { BASE_URL_SERVER } from '../../../ini.json'
import {
  ZustavateData,
  ZustavateDataResponse,
  ZustavateItem,
} from '../../common/zustavateTypes'
import { useAppSelector } from '../../redux/hooks'

export type ZustavateTableItem = Omit<ZustavateItem, 'formData'> &
  Partial<ZustavateData> & {
    propertyTypeLabel?: string
    conditionLabel?: string
    floorAreaLabel?: string
    street?: string
    city?: string
    addressCode?: number
  }

export const useZustavateData = () => {
  const token = useAppSelector(state => state.myProfile.token)

  const [data, setData] = useState<ZustavateTableItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const fetchData = useCallback(
    async (forceRefetch = false) => {
      if (!token || (data.length > 0 && !forceRefetch)) return

      setLoading(true)
      setError(false)

      try {
        const response = await axios.get<ZustavateDataResponse>(
          `${BASE_URL_SERVER}/api/zustavate/data/${token}`
        )
        setData(response.data.data as ZustavateTableItem[])
      } catch (err) {
        console.error('Zustavate data error:', err)
        setError(true)
      } finally {
        setLoading(false)
      }
    },
    [data.length, token]
  )

  const refetch = useCallback(() => {
    fetchData(true)
  }, [fetchData])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, loading, error, refetch }
}
